import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions/index.tsx';
import { INITIAL_STATE } from './constants.tsx';
import type { BacklogEpicsStoreInitProps, State } from './types.tsx';

export const EpicsStore = createStore<State, Actions>({
	name: 'EpicsStore',
	initialState: INITIAL_STATE,
	actions,
});

export const useEpicsStore = createHook(EpicsStore);

// This is mainly used for testing/storybook purposes
export const EpicsStoreDataContainer = createContainer<State, Actions, BacklogEpicsStoreInitProps>(
	EpicsStore,
	{
		onInit: actions.initContainer,
	},
);
